export interface BrandConfig {
  pinIconUrl: string;
}

const brandConfigs: Record<string, BrandConfig> = {
  norlys: {
    pinIconUrl: '/brand/norlys/norlys_pin_icon.png',
  },
};

export function getBrandConfig(
  operatorSlug?: string | null
): BrandConfig | null {
  if (!operatorSlug) return null;
  return brandConfigs[operatorSlug.toLowerCase()] ?? null;
}
